interface IExtraField {
    type: string;
    name: string;
    defaultValue?: string;
    data?: any[];
}

interface IEmailMap {
    [key: string]:
        | {
              type: 'klaviyo';
              list_id: string;
              source: string;
              consent_form_id: string;
              popupBtnLink: string;
          }
        | {
              type: 'emarsys';
              source: string;
          }
        | {
              type: 'mailchimp';
              action: string;
              extraFields?: IExtraField[];
              popupBtnLink?: string;
          };
}

// 已开放站点
export const naLocaleList = ['us', 'ca'];
export const euLocaleList = ['eu', 'uk', 'de', 'fr', 'it', 'es'];
export const otherLocaleList = ['za', 'au', 'kr'];
export const whiteLocaleList = naLocaleList.concat(euLocaleList).concat(otherLocaleList);
// 存在Member-Exclusive Prices模块的站点
export const hasMemberLocale = ['it', 'es', 'eu', 'uk'];
// 存在referral模块的站点
export const hasReferralLocale = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'au', 'kr', 'us', 'ca', 'za', 'jp'];
// kr时间线
const krTimeLine = {
    teaser: {
        start: new Date('2023/12/12 10:00:00 GMT+8').getTime(),
        end: new Date('2023/12/12 10:00:00 GMT+8').getTime(),
    },
    activity: {
        start: new Date('2023/12/12 10:00:00 GMT+8').getTime(),
        end: new Date('2024/01/02 23:00:00 GMT+8').getTime(),
    },
};

// za时间线
const zaTimeLine = {
    teaser: {
        start: new Date('2024/10/21 15:00:00 GMT+8').getTime(),
        end: new Date('2024/10/21 15:00:00 GMT+8').getTime(),
    },
    activity: {
        start: new Date('2024/10/21 15:00:00 GMT+8').getTime(),
        end: new Date('2024/10/28 15:00:00 GMT+8').getTime(),
    },
};

// au时间线
const auTimeLine = {
    teaser: {
        start: new Date('2024/10/08 10:00:00 GMT+8').getTime(),
        end: new Date('2024/10/08 10:00:00 GMT+8').getTime(),
    },
    activity: {
        start: new Date('2024/10/08 10:00:00 GMT+8').getTime(),
        end: new Date('2024/10/17 21:00:00 GMT+8').getTime(),
    },
};

// 北美通用时间线
const naTimeLine = {
    teaser: {
        start: new Date('2024/11/28 16:00:00 GMT+8').getTime(),
        end: new Date('2024/11/28 16:00:00 GMT+8').getTime(),
    },
    activity: {
        start: new Date('2024/11/28 16:00:00 GMT+8').getTime(),
        end: new Date('2024/12/03 16:00:00 GMT+8').getTime(),
    },
};

// uk时间线 年度会员限定版 和正常不同
// const ukTimeLine = {
//     teaser: {
//         start: new Date('2024/03/25 16:00:00 GMT+8').getTime(),
//         end: new Date('2024/03/25 16:00:00 GMT+8').getTime(),
//     },
//     activity: {
//         start: new Date('2024/03/25 16:00:00 GMT+8').getTime(),
//         end: new Date('2024/04/29 15:00:00 GMT+8').getTime(),
//     },
// };

// 欧洲通用时间线
const euTimeLine = {
    teaser: {
        start: new Date('2024/06/17 15:00:00 GMT+8').getTime(),
        end: new Date('2024/06/17 15:00:00 GMT+8').getTime(),
    },
    activity: {
        start: new Date('2023/08/25 15:00:00 GMT+8').getTime(),
        end: new Date('2024/08/25 14:59:59 GMT+8').getTime(),
    },
};

const debug = {
    teaser: {
        start:
            typeof window !== 'undefined' && localStorage.getItem('teaser-start')
                ? new Date(localStorage.getItem('teaser-start') as string).getTime()
                : new Date('2024/10/26 15:00:00 GMT+8').getTime(),
        end:
            typeof window !== 'undefined' && localStorage.getItem('teaser-end')
                ? new Date(localStorage.getItem('teaser-end') as string).getTime()
                : new Date('2024/10/26 15:00:00 GMT+8').getTime(),
    },
    activity: {
        start:
            typeof window !== 'undefined' && localStorage.getItem('activity-start')
                ? new Date(localStorage.getItem('activity-start') as string).getTime()
                : new Date('2024/10/26 15:00:00 GMT+8').getTime(),
        end:
            typeof window !== 'undefined' && localStorage.getItem('activity-end')
                ? new Date(localStorage.getItem('activity-end') as string).getTime()
                : new Date('2024/11/28 22:00:00 GMT+8').getTime(),
    },
};

export const TimeLineProd: {
    [locale: string]: {
        teaser: {
            start: number;
            end: number;
        };
        activity: {
            start: number;
            end: number;
        };
    };
} = {
    // us: debug,
    // ca: debug,
    // eu: debug,
    // fr: debug,
    // de: debug,
    // it: debug,
    // es: debug,
    // uk: debug,
    // za: debug,
    // au: debug,
    // kr: debug,

    us: naTimeLine,
    ca: naTimeLine,
    eu: euTimeLine,
    fr: euTimeLine,
    de: euTimeLine,
    it: euTimeLine,
    es: euTimeLine,
    uk: euTimeLine,
    za: zaTimeLine,
    au: auTimeLine,
    kr: krTimeLine,
};

export const emailMap: IEmailMap = {
    us: {
        type: 'emarsys',
        source: 'ECO_CREDITS_WEEK',
    },
    ca: {
        type: 'emarsys',
        source: 'ECO_CREDITS_WEEK',
    },
    za: {
        type: 'emarsys',
        source: 'ECO_CREDITS_DAY',
    },
    au: {
        type: 'emarsys',
        source: 'ECO_CREDITS_DAY',
    },
    eu: {
        type: 'emarsys',
        source: 'ECO_CREDITS_DAY',
    },
    uk: {
        type: 'emarsys',
        source: 'ECO_CREDITS_DAY',
    },
    de: {
        type: 'emarsys',
        source: 'ECO_CREDITS_DAY',
    },
    fr: {
        type: 'emarsys',
        source: 'ECO_CREDITS_DAY',
    },
    it: {
        type: 'emarsys',
        source: 'ECO_CREDITS_DAY',
    },
    es: {
        type: 'emarsys',
        source: 'ECO_CREDITS_DAY',
    },
    kr: {
        type: 'mailchimp',
        action: 'https://ecoflow.us14.list-manage.com/subscribe/post?u=60f049f50357a87af9abdbbb2&id=31da539bea&f_id=007e90e0f0',
    },
};

export const flashEmailMap: IEmailMap = {
    eu: {
        type: 'emarsys',
        source: 'ECO_CREDITS_FLASH_SUB',
    },
};

export const questionnaireUrl: { [key: string]: string } = {
    us: 'https://zh.surveymonkey.com/r/ecoflowUS07',
    ca: 'https://www.surveymonkey.com/r/ecoflowCA07',
    eu: 'https://www.surveymonkey.com/r/EcoFlowEU8',
    uk: 'https://www.surveymonkey.com/r/EcoFlowUK8',
    de: 'https://www.surveymonkey.com/r/EcoFlowDE8',
    fr: 'https://www.surveymonkey.com/r/EcoFlowFR8',
    it: 'https://www.surveymonkey.com/r/EcoFlowIT8',
    es: 'https://www.surveymonkey.com/r/EcoFlowES8',
};

export const communityUrl: { [key: string]: string } = {
    us: 'https://www.facebook.com/groups/ecoflowclub?ref=ecocredits',
    ca: 'https://www.facebook.com/groups/ecoflowclub?ref=ecocredits',
    eu: 'https://bit.ly/3OnWYFe',
    uk: 'https://bit.ly/3OolS7E',
    de: 'https://bit.ly/3rEy6jL',
    fr: 'https://bit.ly/3rFrguk',
    it: 'https://bit.ly/3rSu33d',
    es: 'https://bit.ly/3OnWYFe',
    za: 'https://www.facebook.com/groups/efsouthafrica',
    au: '/au/referral',
};

export const refurbishUrl: { [key: string]: string } = {
    eu: 'https://eu.ecoflow.com/pages/refurbished',
    uk: 'https://uk.ecoflow.com/pages/refurbished',
    de: 'https://de.ecoflow.com/pages/refurbished',
    fr: 'https://fr.ecoflow.com/pages/refurbished',
    es: 'https://es.ecoflow.com/pages/refurbished',
    it: 'https://it.ecoflow.com/pages/refurbished',
    us: 'https://us.ecoflow.com/collections/black-friday',
    ca: 'https://ca.ecoflow.com/collections/black-friday',
    au: 'https://au.ecoflow.com/collections/ecocredict-week',
};

export const blackFridayUrl: { [key: string]: string } = {
    eu: 'https://eu.ecoflow.com/pages/christmas-sale',
    uk: 'https://uk.ecoflow.com/pages/christmas-sale',
    de: 'https://de.ecoflow.com/pages/christmas-sale',
    fr: 'https://fr.ecoflow.com/pages/christmas-sale',
    es: 'https://es.ecoflow.com/pages/christmas-sale',
    it: 'https://it.ecoflow.com/pages/christmas-sale',
};
